// @flow
import env from 'utils/env';
import isPublicPage from 'utils/public-pages';
import cookie from 'utils/cookie';

function handleUnauthorizedReq(): Promise<void> {
  window.location.replace(
    `https://login.${env.hostname}?origin=${window.location.href}`
  );
  // Returning a promise that never resolves so that we can await this function call,
  // which allows us to ensure that no code is executed after this function returns.
  // In doing so, we eliminate a possible race condition where a later line of code
  // could send the user to a page other than the login page, like the oops page.
  return new Promise(() => {});
}

async function request(
  path: string,
  method?: string = 'GET',
  headers?: { [string]: any } = {},
  body?: string,
  json?: boolean = true,
  parseResponse?: boolean = true,
  notRequiredResponseOnDelete?: boolean = true
): Promise<any> {
  const isLocalAceApi = path.includes('localhost:8089');
  const defaultHeaders = {
    'FFF-Auth': 'V1.1',
    Origin: env.hostname,
    ...(isLocalAceApi && {
      Authorization: `Bearer ${cookie.get('Jwt')})`,
    }),
  };

  const response = await fetch(path, {
    headers: { ...headers, ...defaultHeaders },
    data: {
      activatedOn: true,
    },
    body,
    mode: 'cors',
    method,
    ...(!isLocalAceApi && {
      credentials: 'include',
    }),
  });

  if (!parseResponse) return response;

  if (response.ok && method === 'DELETE' && notRequiredResponseOnDelete) return;

  // only redirect to login page if the request is to an ace-api endpoint
  if (path.match(/ace-api/) && response.status === 401 && !isPublicPage) {
    await handleUnauthorizedReq();
  }

  if (!response.ok) {
    const errorText = await response.text();
    throw errorText;
  }
  const parsedResponse = json ? response.json() : response.text();
  return parsedResponse;
}

export default request;
